import ReactDOM from 'react-dom/client';
import React from 'react';
import { TenantContext } from '../../context/tenant-context';
import { v2Component } from '../../index';
import { InsuranceFormWrapper } from './insurance-wrapper';
import { ToastContainer } from 'react-toastify';
import { CustomerContextProvider } from '../../context/customer-context';

const InsuranceV1 = ({
  hideFile,
  setRootAttributes,
  props,
}: {
  hideFile: string;
  setRootAttributes: (...args: any) => void;
  props: any;
}) => {
  const [isEditing, setIsEditing] = React.useState<boolean>(false);

  return (
    <CustomerContextProvider>
      <InsuranceFormWrapper
        hideFile={hideFile === 'true'}
        setRootAttributes={setRootAttributes}
        {...props}
        isEditing={isEditing}
        setIsEditing={setIsEditing}
      />
    </CustomerContextProvider>
  );
};

export function initInsuranceForm() {
  document.getElementsByName('insurance-form-wrapper-v2').forEach((element) => {
    if (element.getAttribute('initialized') !== 'true') {
      element.setAttribute('initialized', 'true');
      const setRootAttributes = (o: any) => {
        Object.keys(o).forEach((k) => {
          element.setAttribute(k, o[k]);
        });
      };
      const root = ReactDOM.createRoot(element);
      const { tenant, contextPath, hideFile, ...props } = Object.assign({}, element.dataset) as any;
      root.render(
        v2Component(
          <TenantContext.Provider value={{ tenant, contextPath, spaMode: false }}>
            <ToastContainer />
            <InsuranceV1 hideFile={hideFile} setRootAttributes={setRootAttributes} props={props} />
          </TenantContext.Provider>,
        ),
      );

      const event = new CustomEvent('change');
      element.dispatchEvent(event);
    }
  });
}
